import { WhatsappData } from '@wix/ambassador-chat-channels-v1-channel/types';
import { useTranslation } from '@wix/wix-i18n-config';
import React from 'react';
import { useTheme } from '../../hooks/theme';
import { ChannelCard } from '../ChannelCard/ChannelCard';

export interface WhatsappScreenProps {
  data: WhatsappData;
}

export const WhatsappScreen: React.FunctionComponent<WhatsappScreenProps> = ({
  data,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const backgroundColor = theme.chatWeb.room.background;
  const backgroundImage = theme.chatWeb.room.pattern.asset;
  const backgroundSize = theme.chatWeb.room.pattern.backgroundSize;
  const fontFamily = theme.chatWeb.room.fontFamily;

  const link = `https://wa.me/${data.phone}?text=${data.introMessage}`;
  const whatsappColor = '#4E9A8C';
  return (
    <div
      style={{
        backgroundColor,
        backgroundImage,
        backgroundSize,
        fontFamily,
        height: '100%',
      }}
    >
      <div
        style={{
          margin: '35px 0px 0px 25px',
        }}
      >
        <ChannelCard
          link={link}
          buttonText={t('channels.whatsapp.open')}
          description={data.description || ''}
          buttonBackground={whatsappColor}
        ></ChannelCard>
      </div>
    </div>
  );
};
